import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const adminApi = axios.create({ baseURL: API });

adminApi.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("wyv_admin_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

adminApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && window.location.pathname.startsWith("/admin")) {
      localStorage.removeItem("wyv_admin_token");
      localStorage.removeItem("wyv_admin");
      if (window.location.pathname !== "/admin") window.location.href = "/admin";
    }
    return Promise.reject(err);
  }
);

export const assetUrl = (path) => {
  if (!path) return null;
  return path.startsWith("http") ? path : `${BACKEND_URL}${path}`;
};

export const getAdmin = () => {
  try {
    return JSON.parse(localStorage.getItem("wyv_admin") || "null");
  } catch {
    return null;
  }
};
